/**
 * Configuration for frontend API endpoints
 * Supports environment-specific overrides via Vite env vars
 */

export const API_URL = 
  import.meta.env.VITE_API_URL || 
  'https://progeny-api.max-4ff.workers.dev/api';

export const MODAL_VISION_URL = 
  import.meta.env.VITE_MODAL_VISION_URL || 
  'https://max-51632--progeny-vision-text-to-pattern.modal.run';

export const MODAL_IMAGE_ANALYSIS_URL = 
  import.meta.env.VITE_MODAL_IMAGE_ANALYSIS_URL || 
  'https://max-51632--progeny-vision-analyze-image.modal.run';

/**
 * Get the full API endpoint URL
 */
export function getApiUrl(path: string): string {
  return `${API_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

/**
 * Health check to verify API connectivity
 */
export async function checkApiHealth(): Promise<boolean> {
  try {
    const baseUrl = API_URL.replace(/\/api$/, '');
    const response = await fetch(`${baseUrl}/health`, { 
      mode: 'cors',
      credentials: 'omit'
    });
    return response.ok;
  } catch {
    return false;
  }
}
